import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ConstructionIcon from '@mui/icons-material/Construction';

const MaintenancePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Box sx={{ 
      minHeight: '100vh',
      height: '100%', 
      bgcolor: '#e0e0e0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: {
        xs: 2,
        sm: 3
      },
      textAlign: 'center',
      boxSizing: 'border-box'
    }}>
      <ConstructionIcon sx={{ 
        fontSize: {
          xs: '48px',
          sm: '64px'
        },
        color: '#1e262a',
        mb: 3
      }} />
      <Typography variant="h4" sx={{ 
        color: '#1e262a',
        mb: 2,
        fontWeight: 500,
        letterSpacing: 1,
        fontSize: {
          xs: '1.5rem',
          sm: '2rem'
        }
      }}>
        ขออภัย ระบบอยู่ระหว่างการปรับปรุง
      </Typography>
      <Typography sx={{ 
        color: '#666',
        mb: 4,
        maxWidth: '600px',
        px: 2,
        fontSize: {
          xs: '0.875rem',
          sm: '1rem'
        }
      }}>
        เรากำลังพัฒนาระบบเพื่อประสบการณ์ที่ดียิ่งขึ้น กรุณากลับมาใหม่ในภายหลัง
      </Typography>
      <Button
        variant="contained"
        onClick={() => navigate('/')}
        sx={{
          bgcolor: '#1e262a',
          color: '#fff',
          px: {
            xs: 3,
            sm: 4
          },
          py: 1.5,
          textTransform: 'none',
          fontSize: {
            xs: '0.875rem',
            sm: '1rem'
          },
          letterSpacing: 1,
          '&:hover': {
            bgcolor: '#2c363c'
          }
        }}
      >
        กลับสู่หน้าหลัก
      </Button>
    </Box>
  );
};

export default MaintenancePage; 